import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/amenity`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all amenities with pagination
export const fetchAmenitiesTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all amenities
export const fetchAmenities = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch an amenity by ID
export const fetchAmenityById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new amenity
export const addAmenity = async (newAmenity: { name: string; description: string; popular: boolean; is_more: boolean; photo?: string }) => {
  const response = await axios.post(API_URL, newAmenity, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Edit an existing amenity
export const updateAmenity = async (id: string, updatedAmenity: { name: string; description: string; popular: boolean; is_more: boolean; photo?: string }) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedAmenity, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Delete an amenity
export const removeAmenity = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
